// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.color-palette-box-container[data-v-6ac63306] {
  width: fit-content;
  height: fit-content;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  background-color: #fff;
  border: 1px solid #fff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 3px 2px #bababa
}
.color-palette-box-container.no-box-shadow[data-v-6ac63306] {
  box-shadow: none;
  width: 100%;
  height: 120px;
  padding: 0;
  gap: unset;
}
.color-palette-box[data-v-6ac63306] {
  width: 45px;
  height: 30px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.color-palette-box[data-v-6ac63306]:hover,
.color-palette-box[data-v-6ac63306]:focus {
  cursor: pointer;
  scale: 1.1;
  transition: .2s;
}
.white-color-font[data-v-6ac63306] {
  color: #fff;
}
@media (max-width: 600px) {
.color-palette-box-container[data-v-6ac63306]:not(.no-box-shadow) {
    grid-template-columns: repeat(3, 1fr);
}
}
`, "",{"version":3,"sources":["webpack://./src/vue/ColorBox.vue"],"names":[],"mappings":";AAgDA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB;AACF;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,UAAU;EACV,UAAU;AACZ;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;AACb;AAEA;AACE;IACE,qCAAqC;AACvC;AACF","sourcesContent":["<script>\nimport { OPLUS_COLOR_PALETTE } from '../js/models.js'\n\n export default {\n  props: {\n    isVisible: Boolean,\n    selectedColor: String,\n    useForModal: {\n      type: Boolean,\n      default: false,\n    }\n  },\n  methods: {\n    handleClickedColor(colorStr) {\n      return this.$emit('color-select', colorStr);\n    },\n  },\n  computed: {\n    colorPalette() {\n      return OPLUS_COLOR_PALETTE;\n    },\n    isDefaultColor() {\n      return this.selectedColor === OPLUS_COLOR_PALETTE.DEFAULT;\n    },\n    defaultCheckColor() {\n      return !this.isDefaultColor ? \"white-color-font\" : \"\";\n    }\n  },\n  emits: [\n    \"color-select\"\n  ],\n }\n</script>\n\n<template>\n  <div id=\"color-box-container\" v-show=\"isVisible\">\n    <div class=\"color-palette-box-container\" :class=\"{'no-box-shadow': useForModal}\">\n      <div v-for=\"colorHexString, _ in colorPalette\">\n        <div @click=\"handleClickedColor(colorHexString)\" class=\"color-palette-box\" :style=\"{ backgroundColor: `#${colorHexString}` }\">\n          <i v-show=\"this.selectedColor === colorHexString\" :class=\"defaultCheckColor\" class=\"zmdi zmdi-check zmdi-hc-2x\"></i>\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<style scoped>\n\n.color-palette-box-container {\n  width: fit-content;\n  height: fit-content;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 10px;\n  background-color: #fff;\n  border: 1px solid #fff;\n  padding: 10px;\n  border-radius: 5px;\n  box-shadow: 0px 0px 3px 2px #bababa\n}\n\n.color-palette-box-container.no-box-shadow {\n  box-shadow: none;\n  width: 100%;\n  height: 120px;\n  padding: 0;\n  gap: unset;\n}\n\n.color-palette-box {\n  width: 45px;\n  height: 30px;\n  border-radius: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.color-palette-box:hover,\n.color-palette-box:focus {\n  cursor: pointer;\n  scale: 1.1;\n  transition: .2s;\n}\n.white-color-font {\n  color: #fff;\n}\n\n@media (max-width: 600px) {\n  .color-palette-box-container:not(.no-box-shadow) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
